module.exports = __webpack_public_path__ + "static/media/ErrorTrashIcon.49d733cd.svg";